export function AnnouncementBar() {
  return (
    <div className="bg-beige text-black py-2 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-center items-center text-center sm:text-left space-y-1 sm:space-y-0 sm:space-x-8">
          <div className="flex items-center">
            <span className="text-sm italic">57 E Kings Hwy, Audubon, NJ 08016</span>
          </div>
          <div className="flex items-center">
            <a
              href="mailto:office@musiclessonsinsouthjersey.com"
              className="text-sm hover:underline italic"
            >
              office@musiclessonsinsouthjersey.com
            </a>
          </div>
          <div className="flex items-center">
            <a
              href="tel:856-354-1432"
              className="text-sm hover:underline italic"
            >
              856-354-1432
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}